var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStampFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stampFile)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.2857,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.2857,
    height: 48,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4113 0V11.926C8.39106 13.231 6.56308 16.5291 7.32085 19.9188L9.80502 31.0312H6.14775L3.31851 39.4688H0V48C1.72178 48 45.7539 48 48.2857 48V0H11.4113ZM14.2405 14.1562C16.9679 14.1562 18.9889 16.6669 18.3984 19.3088L15.7778 31.0312H12.7032L10.0827 19.3088C9.49097 16.6617 11.5184 14.1562 14.2405 14.1562ZM8.18707 33.8438H20.2941L22.1802 39.4688H6.30091L8.18707 33.8438ZM25.5575 45.1875H2.82924V42.2812H25.5575V45.1875ZM45.4565 45.1875H28.3867V39.4688H25.1625L22.3333 31.0312H18.6761L21.1603 19.9189C22.1449 15.5135 18.7706 11.3438 14.2405 11.3438V2.8125H45.4565V45.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7582 12.7586L42.25 10.7812L39.9866 9.09375L38.7932 10.6757C37.1007 9.33422 34.9584 8.53125 32.6306 8.53125C27.1705 8.53125 22.7283 12.9472 22.7283 18.375C22.7283 23.8028 27.1705 28.2188 32.6306 28.2188C38.0908 28.2188 42.533 23.8028 42.533 18.375C42.533 16.2889 41.8762 14.3526 40.7582 12.7586ZM32.6306 25.4062C28.7305 25.4062 25.5575 22.252 25.5575 18.375C25.5575 14.498 28.7305 11.3438 32.6306 11.3438C34.3223 11.3438 35.8766 11.9378 37.0952 12.9263L32.4776 19.0466L30.8016 17.3806L28.8011 19.3693L32.7836 23.3283L38.9294 15.1824C39.4232 16.1413 39.7037 17.2259 39.7037 18.375C39.7037 22.252 36.5307 25.4062 32.6306 25.4062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 80.4762,
    y1: 62.8148,
    x2: 18.6152,
    y2: 25.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#225FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A89DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stampFile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.2857,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampFile);
export default __webpack_public_path__ + "static/media/stampFile.6e4ee8a1f3d8ba022c4c59087b7186eb.svg";
export { ForwardRef as ReactComponent };